import { deviceType } from "@tm/static/utils";
import styled from "styled-components";

import { theme } from "@tm/utility/global";

export interface InnerLinksContainerProps {
  footerTheme?: string;
}

export interface LandingFooterStyleProps {
  footerTheme?: string;
  isCommonLandingRevamp?: boolean;
}

export const LandingFooterStyle = styled.section<LandingFooterStyleProps>`
  background: ${({ footerTheme, isCommonLandingRevamp }) =>
    footerTheme === "light"
      ? isCommonLandingRevamp
        ? theme.lightGreyBG
        : theme.whiteText
      : theme.blackText};
  color: ${({ footerTheme }) =>
    footerTheme === "light" ? theme.blackText : theme.whiteText};
  padding: ${({ footerTheme }) =>
    footerTheme === "light" ? "0" : "32px 0 64px"};
  width: 100%;

  @media screen and ${deviceType.mobile} {
    padding-bottom: 22px;
  }
`;

type ChevronContainerIconProps = {
  isInvert?: boolean;
};

export const ChevronContainerIcon = styled.span<ChevronContainerIconProps>`
  transform: ${(props) => (props.isInvert ? "rotate(180deg)" : "rotate(0deg)")};
`;

type LinksContainerProps = {
  isCopyrightText?: boolean;
};

export const LinksContainer = styled.ul<LinksContainerProps>`
  margin-bottom: ${(p) => (p.isCopyrightText ? "100px" : "0")};

  & > li:not(:last-child) {
    margin-bottom: 20px;
  }

  & > li:hover {
    text: ${theme.blueText};
  }

  @media screen and ${deviceType.mobile} {
    margin-bottom: 40px;

    & > li {
      padding: 16px;
      border-bottom: 1px ${theme.greyText} solid;
    }

    & > li:not(:last-child) {
      margin-bottom: unset;
    }
  }
`;

export const FooterSection = styled.div`
  @media screen and ${deviceType.mobile} {
    width: 100%;
  }
`;

export const InnerLinksContainer = styled.div<InnerLinksContainerProps>`
  display: flex;
  margin-top: 10px;
  flex-wrap: wrap;
  width: 100%;
  color: ${({ footerTheme }) =>
    footerTheme === "light" ? theme.greyText : theme.whiteText};
  font-size: 12px;
  line-height: 16px;
`;

export const LandingFooterWrap = styled.div`
  margin: 0 auto;
  width: 1200px;

  @media screen and ${deviceType.mobile} {
    width: 100%;
  }
`;
